import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { Button } from '../components/ui/Button';
import { ArrowUpRight } from 'lucide-react';
export function Publication() {
  const articles = [{
    title: 'The Architecture of Exclusion',
    author: 'Jordan Miller',
    category: 'Essay',
    excerpt: 'How public spaces are designed to police fat bodies, and what a truly accessible city would look like.'
  }, {
    title: 'Hunger as Resistance',
    author: 'Sam Rivera',
    category: 'Poetry',
    excerpt: 'Reclaiming appetite in a world that demands our starvation.'
  }, {
    title: 'Beyond Representation',
    author: 'Alex Chen',
    category: 'Critique',
    excerpt: "Why seeing fat people on TV isn't enough to save us."
  }];
  return <div className="min-h-screen bg-brand-cream" data-id="element-1264">
      <HeroSection title="The Digital Publication" subtitle="A journal of fat thought, art, and politics." tag="Editorial" bgColor="orange" textColor="white" data-id="element-1265" />

      {/* Masthead / Mission */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-1266">
        <span className="text-brand-orange font-bold tracking-widest uppercase mb-4 block" data-id="element-1267">
          Our Mission
        </span>
        <h2 className="text-3xl md:text-5xl font-serif font-medium text-brand-black mb-8 leading-tight" data-id="element-1268">
          "We publish work that challenges, expands, and deepens the
          conversation around fat justice."
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-1269">
          We are not interested in 101-level explainers for thin audiences. This
          is a space for fat people to talk to each other.
        </p>
      </section>

      {/* Recent Work Preview */}
      <section className="py-20 bg-white border-y border-gray-200" data-id="element-1270">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1271">
          <div className="flex justify-between items-center mb-12" data-id="element-1272">
            <h2 className="text-4xl font-black uppercase text-brand-black" data-id="element-1273">
              Recent Stories
            </h2>
            <Button variant="ghost" color="orange" withArrow data-id="element-1274">
              View Archive
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-1275">
            {articles.map((article, index) => <div key={index} className="group cursor-pointer" data-id="element-1276">
                <div className="aspect-[4/3] bg-gray-100 mb-6 overflow-hidden relative" data-id="element-1277">
                  {/* Placeholder for article image */}
                  <div className="absolute inset-0 bg-brand-orange/10 group-hover:bg-brand-orange/20 transition-colors" data-id="element-1278"></div>
                </div>
                <div className="flex items-center space-x-2 text-xs font-bold uppercase tracking-wider text-brand-orange mb-3" data-id="element-1279">
                  <span data-id="element-1280">{article.category}</span>
                  <span className="text-gray-300" data-id="element-1281">•</span>
                  <span className="text-gray-500" data-id="element-1282">{article.author}</span>
                </div>
                <h3 className="text-2xl font-bold text-brand-black mb-3 group-hover:text-brand-orange transition-colors" data-id="element-1283">
                  {article.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1284">
                  {article.excerpt}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-4 text-center" data-id="element-1285">
        <div className="max-w-3xl mx-auto border-2 border-brand-black p-12 bg-brand-orange/5" data-id="element-1286">
          <h2 className="text-3xl font-black uppercase mb-6" data-id="element-1287">
            Read The Full Publication
          </h2>
          <p className="text-lg text-gray-700 mb-8" data-id="element-1288">
            Visit our dedicated editorial platform to read all essays, poetry,
            and reporting.
          </p>
          <a href="#" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-brand-orange hover:bg-brand-orange/90 transition-all shadow-lg hover:-translate-y-1 uppercase tracking-wide" data-id="element-1289">
            Go to Publication <ArrowUpRight className="ml-2 h-5 w-5" data-id="element-1290" />
          </a>
        </div>
      </section>
    </div>;
}